import dayjs from 'dayjs';
/** 获取mock变量 */
export const getMockVar = (key: string) => window.__mock__?.[key];
/** 抽奖开始时间 */
export const LOTTERY_START_TIME = getMockVar('LOTTERY_START_TIME') || dayjs('2026-01-14T00:00:00+08:00').toDate();
/** 抽奖结束时间 */
export const LOTTERY_END_TIME = getMockVar('LOTTERY_END_TIME') || dayjs('2026-02-15T23:59:59+08:00').toDate();
/** 推广展示结束时间（用于 Banner 文案计算） */
export const PROMOTION_END_TIME = getMockVar('PROMOTION_END_TIME') || dayjs('2026-02-13T23:59:59+08:00').toDate();

/** banner-活动进行中 */
export const LOTTERY_BANNER = 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20251230145447/banner1230.png';

/** 牌照号码 */
export const LICENSE_NUMBER = '060998-9';

export const INFO_DIALOG_CONFIG = {
  // 信息弹窗图片
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  picture: require('../images/lottery-info-new-tiny.png'),
  // TNC 链接
  tncUrl: 'https://hkwallet.moneydata.hk/hkwalletv3/tnc/index.shtml#/?type=vitasoy&tncId=vita2601',
  // TODO: 与运营确认底部文字
  bottomText: `推廣時間：2026年1月14日-2026年2月13日（首尾兩天包含在內）<br />
推廣生意的競賽牌照號碼：${LICENSE_NUMBER}<br />
<br />
參與本推廣活動，每次抽獎將有機會隨機獲得價值HK$668 電子現金券、價值HK$88電子現金券、價值HK$8電子現金券、價值HK$1 電子現金券或價值HK$2維他®冷泡無糖茶優惠券1張。<br />
<br />
本推廣活動受相關條款及細則約束<br />
<br />
有關本推廣活動資訊（包括有效實體購物單據的上傳、審核、資料收集及價值HK$2優惠券的使用等）及維他奶國際集團有限公司（"維他奶公司"）提供之產品的質量事宜均由維他奶公司自行負責，用戶應直接向維他奶公司查詢及反映，WeChat Pay Hong Kong對前述資訊及事項（包括任何有關產品質量或因產品自身引起的任何責任）概不負責。`,
};

/** 不允许展示且不能抽奖的adtag(存量维他奶活动) */
export const NOT_ALLOW_ADTAGS = ['bottlecap'];

/** 用于用户分享的adtag */
export const LOTTERY_ADTAG_SHARE = 'lottery2601';

/** 携带抽奖cdkey的adtag: 来源于whatsapp */
export const LOTTERY_ADTAG_WHATSAPP = '2601whatsapp';

